// extracted by mini-css-extract-plugin
export var expandIcon = "ft_vs";
export var rotated = "ft_vt";